// extracted by mini-css-extract-plugin
export default {"bottomSection":"BottomSection_bottomSection__1wdOO","btn":"BottomSection_btn__fvOWZ","codeProblem":"BottomSection_codeProblem__yQOob","loader":"BottomSection_loader__dlaPQ"};